import { useEffect, useRef, useState } from "react";
import { Ring } from "@uiball/loaders";
import PropTypes from "prop-types";

import { alignItems, colors, strCode } from "../../../../../../consts";
import { t } from "../../../../../../services";
import { useScrollPosition, useWindowWidth } from "../../../../../../hooks";

import { FlexContainers, Paragraph2, WrapperContainer } from "../../../../../../components";
import { HistoryItem } from "./components/HistoryItem/HistoryItem";
import {
  ChangeHistoryListWrapper,
  ChangeHistoryListStyled,
  FirstItemWrapper,
  AbsoluteContainer,
  BottomBorder
} from "./styled";

export const ChangeHistoryList = ({ history = [], loading, isAdminUser }) => {
  const scrollContainerRef = useRef(null);

  const firstItemRef = useRef(null);
  const [firstItemHeight, setFirstItemHeight] = useState(54);

  const windowWidth = useWindowWidth();

  const { hasScroll, isScrolledTop, isScrolledBottom, handleScroll } =
    useScrollPosition(scrollContainerRef);

  useEffect(() => {
    if (firstItemRef?.current) {
      setFirstItemHeight(firstItemRef.current.offsetHeight);
    }
  }, [firstItemRef, windowWidth]);

  return (
    <ChangeHistoryListWrapper
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      isAdminUser={isAdminUser}>
      <ChangeHistoryListStyled
        Container={FlexContainers.FlexColumnStart}
        alignItems={alignItems.start}
        width={"100%"}
        height={"100%"}
        innerRef={scrollContainerRef}
        isScrolledTop={isScrolledTop || !hasScroll}
        onScroll={handleScroll}>
        {history?.length ? (
          history.map((record, index) => {
            if (index === 0) {
              return (
                <FirstItemWrapper key={record.timestamp}>
                  <WrapperContainer
                    Container={FlexContainers.FlexColumn}
                    height={firstItemHeight}
                  />

                  <AbsoluteContainer
                    innerRef={firstItemRef}
                    isScrolledTop={isScrolledTop || !hasScroll}>
                    <HistoryItem
                      record={record}
                      isFirstRecord={index === 0}
                      isLastRecord={index === history.length - 1}
                    />
                  </AbsoluteContainer>
                </FirstItemWrapper>
              );
            }

            return (
              <HistoryItem
                key={record.timestamp}
                record={record}
                isFirstRecord={index === 0}
                isLastRecord={index === history.length - 1}
              />
            );
          })
        ) : loading ? (
          <WrapperContainer
            Container={FlexContainers.FlexColumnCenter}
            alignItems={alignItems.center}
            width={"100%"}
            height={"100%"}>
            <Ring size={48} lineWeight={5} speed={2} color={colors.RAISIN_100} />
          </WrapperContainer>
        ) : (
          <WrapperContainer
            Container={FlexContainers.FlexColumnCenter}
            alignItems={alignItems.center}
            width={"100%"}
            height={"100%"}>
            <Paragraph2>{t(strCode.NO_DATA)}</Paragraph2>
          </WrapperContainer>
        )}
      </ChangeHistoryListStyled>
      <BottomBorder isScrolledBottom={isScrolledBottom || !hasScroll} />
    </ChangeHistoryListWrapper>
  );
};

ChangeHistoryList.propTypes = {
  history: PropTypes.arrayOf(
    PropTypes.shape({
      timestamp: PropTypes.number.isRequired,
      adminEmail: PropTypes.string.isRequired,
      action: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    }).isRequired
  ),
  loading: PropTypes.bool,
  isAdminUser: PropTypes.bool
};
